import ProjectTaskStatus from '../../../pages/project-management-pmr/shared/enums/project-task-status'
import PmrE2EProjectTaskModel from '../../../pages/project-management-pmr/shared/interfaces/pmr-e2e-project-task-model'

const computePredefinedAggregateTaskStatus = (taskStatuses: ProjectTaskStatus[]) => {
  let statusValue: ProjectTaskStatus = ProjectTaskStatus.InProgress

  if (taskStatuses.some(status => status === ProjectTaskStatus.InProgress))
    statusValue = ProjectTaskStatus.InProgress
  else if (taskStatuses.some(status => status === ProjectTaskStatus.OnHold))
    statusValue = ProjectTaskStatus.OnHold
  else if (
    taskStatuses.some(status =>
      [
        ProjectTaskStatus.NotScheduled,
        ProjectTaskStatus.AwaitingAssignment,
        ProjectTaskStatus.NotStarted,
      ].includes(status)
    )
  )
    statusValue = ProjectTaskStatus.NotScheduled
  else if (taskStatuses.some(status => status === ProjectTaskStatus.Completed))
    statusValue = ProjectTaskStatus.Completed
  else if (taskStatuses.every(status => status === ProjectTaskStatus.Cancelled))
    statusValue = ProjectTaskStatus.Cancelled
  else if (taskStatuses.every(status => status === ProjectTaskStatus.Discontinued))
    statusValue = ProjectTaskStatus.Discontinued

  return statusValue
}

const computeAdHocAggregateTaskStatus = (taskStatuses: ProjectTaskStatus[]) => {
  let statusValue: ProjectTaskStatus = ProjectTaskStatus.InProgress

  if (taskStatuses.some(status => status === ProjectTaskStatus.InProgress))
    statusValue = ProjectTaskStatus.InProgress
  else if (taskStatuses.some(status => status === ProjectTaskStatus.OnHold))
    statusValue = ProjectTaskStatus.OnHold
  else if (taskStatuses.some(status => status === ProjectTaskStatus.AwaitingAssignment))
    statusValue = ProjectTaskStatus.AwaitingAssignment
  else if (taskStatuses.some(status => status === ProjectTaskStatus.NotStarted))
    statusValue = ProjectTaskStatus.NotStarted
  else if (taskStatuses.some(status => status === ProjectTaskStatus.NotScheduled))
    statusValue = ProjectTaskStatus.NotScheduled
  else if (taskStatuses.some(status => status === ProjectTaskStatus.Completed))
    statusValue = ProjectTaskStatus.Completed
  else if (taskStatuses.every(status => status === ProjectTaskStatus.Cancelled))
    statusValue = ProjectTaskStatus.Cancelled
  else if (taskStatuses.every(status => status === ProjectTaskStatus.Discontinued))
    statusValue = ProjectTaskStatus.Discontinued

  return statusValue
}

export const calculateOrderlinesTaskStatus = (task: PmrE2EProjectTaskModel) => {
  const taskStatuses = task.e2EProjectLineFlexTaskGroupItems.map(item => item.flexTaskStatus)

  if (!task.isAdHoc) return computePredefinedAggregateTaskStatus(taskStatuses)
  else return computeAdHocAggregateTaskStatus(taskStatuses)
}
